import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import requestErrorTreatment from "@shared/utils/requestErrorTreatment";
import { TiledeskDashboardAccess } from "@modules/tiledesk/types";
import {
  OpenTiledeskDashboardInput,
  openTiledeskDashboardService,
} from "./service";

export function useOpenTiledeskDashboardMutation() {
  const { open } = useNotification();

  return useMutation<TiledeskDashboardAccess, ApiError, OpenTiledeskDashboardInput>({
    mutationFn: openTiledeskDashboardService,
    onError: (error: ApiError) => {
      requestErrorTreatment(error, open);
    },
  });
}
